import { render, staticRenderFns } from "./viewer-ebs.vue?vue&type=template&id=533cd21e"
import script from "./viewer-ebs.vue?vue&type=script&lang=js"
export * from "./viewer-ebs.vue?vue&type=script&lang=js"
import style0 from "./viewer-ebs.vue?vue&type=style&index=0&id=533cd21e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports